import React from 'react';
import { PageSection } from '../Layout';
import { Message } from '../Core';
import Page from './Core/Page';

const Error404Page = () => (
  <Page>
    <PageSection>
      <Message error>This page could not be found.</Message>
    </PageSection>
  </Page>
);

export default Error404Page;
